module.exports = [
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en C",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: mezclador de cocina monomando para agua filtrada, fría y con gas. Incluye unidad refrigeradora, filtro y botella de CO2 para carbonatación. Caño alto en C, acabado cromado.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en C",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: mezclador de cocina monomando para agua filtrada, fría y con gas. Incluye unidad refrigeradora, filtro y botella de CO2 para carbonatación. Caño alto en C, efecto acero inoxidable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en U",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: mezclador de cocina monomando para agua filtrada, fría y con gas. Incluye unidad refrigeradora, filtro y botella de CO2 para carbonatación. Caño alto en U, acabado cromado.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en U",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: mezclador de cocina monomando para agua filtrada, fría y con gas. Incluye unidad refrigeradora, filtro y botella de CO2 para carbonatación. Caño alto en U, efecto acero inoxidable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: grifo de fregadero para agua filtrada, fría y con gas. Incluye unidad refrigeradora, filtro y botella de CO2 para carbonatación. Caño alto en C, acabado cromado.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: grifo de fregadero para agua filtrada, fría y con gas. Incluye unidad refrigeradora, filtro y botella de CO2 para carbonatación. Caño alto en C, efecto acero inoxidable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en L",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: mezclador de cocina monomando para agua filtrada, fría y con gas. Incluye unidad refrigeradora, filtro y botella de CO2 para carbonatación. Caño alto en L, acabado cromado.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en L",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: mezclador de cocina monomando para agua filtrada, fría y con gas. Incluye unidad refrigeradora, filtro y botella de CO2 para carbonatación. Caño alto en L, efecto acero inoxidable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "Grifo de cocina GROHE Red Duo (caño en L) con sistema de filtro y calentador tamaño L para disfrutar de agua hirviendo al instante. Acabado cromado. Características de seguridad y etiqueta energética clase A",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "Grifo de cocina GROHE Red Duo (caño en L) con sistema de filtro y calentador tamaño L para disfrutar de agua hirviendo al instante. Acabado efecto acero inoxidable mate. Características de seguridad y etiqueta energética clase A",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Grifo de fregadero y calentador Tamaño L",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "Grifo de cocina GROHE Red Mono (caño en C) con sistema de filtro y calentador tamaño L para disfrutar de agua hirviendo al instante. Acabado cromado. Características de seguridad y etiqueta energética clase A",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Grifo de fregadero y calentador Tamaño M",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "Grifo de cocina GROHE Red Mono (caño en C) con sistema de filtro y calentador tamaño M para disfrutar de agua hirviendo al instante. Acabado cromado. Características de seguridad y etiqueta energética clase A",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "Grifo de cocina GROHE Red Duo (caño en C) con sistema de filtro y calentador tamaño L para disfrutar de agua hirviendo al instante. Acabado cromado. Características de seguridad y etiqueta energética clase A",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "Grifo de cocina GROHE Red Duo (caño en C) con sistema de filtro y calentador tamaño L para disfrutar de agua hirviendo al instante. Efecto acero inoxidable mate. Características de seguridad y etiqueta energética clase A",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "Grifo de cocina GROHE Red Duo (caño en C) con sistema de filtro y calentador tamaño M para disfrutar de agua hirviendo al instante. Acabado cromado. Características de seguridad y etiqueta energética clase A",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "Grifo de cocina GROHE Red Duo (caño en C) con sistema de filtro y calentador tamaño M para disfrutar de agua hirviendo al instante. Efecto acero inoxidable mate. Características de seguridad y etiqueta energética clase A",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "Grifo de cocina GROHE Red Duo (caño en L) con sistema de filtro y calentador tamaño M para disfrutar de agua hirviendo al instante. Efecto acero inoxidable mate. Características de seguridad y etiqueta energética clase A",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "Grifo de cocina GROHE Red Duo (caño en L) con sistema de filtro y calentador tamaño M para disfrutar de agua hirviendo al instante. Acabado cromado. Características de seguridad y etiqueta energética clase A",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_es_es.json
// module id = 878
// module chunks = 0